<section
  fxLayout="row wrap"
  fxLayoutAlign="center center"
  class="modal-container"
>
  <div
    fxFlex.gt-sm="50%"
    fxHide fxShow.gt-sm
    class="background-image"
  >
  </div>
  <div
    fxFlex.gt-sm="50%"
    fxlayout="column"
    fxLayoutAlign="center center"
  >
    <img
      src="/assets/icons/shapes/close.svg"
      alt=""
      class="close-modal"
      (click)="this.dialogRef.close();"
    >
    <mat-dialog-content>
      <div
        fxLayout="column"
        fxLayoutAlign="space-between center"
        class="modal-content-container"
      >
        <a
          fxLayout="row"
          fxLayoutAlign="center center"
          [routerLink]="basePath"
        >
          <img
            [src]="agencyService.agency.logo.url ? agencyService.agency.logo.url : '/assets/icons/logo.svg'"
            [alt]="agencyService.agency.name"
            class="logo"
          >
        </a>
        <app-contact-form-base [title]="'Formular de contact'"></app-contact-form-base>
        <app-social-icons-base [isTooltipBelow]="true"></app-social-icons-base>
      </div>
    </mat-dialog-content>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-contact-form-modal-base/show-contact-form-modal-base.component.html